import chatbotImage from "/src/assets/recommenderImage1.png";
import currentPoint from "/src/assets/currentPoint.svg";
import currentSelectPoint from "/src/assets/currentSelectPoint.svg";

export default function RecommenderWelcomeChatbot({sendNavigationChange}){
    return <div className="bot-utn-recommender">
        <img className="bot-utn-recommender-image" width={200} height={200} src={chatbotImage}/>
        <div className="bot-utn-recommender-index-points">
            <img className="bot-utn-recommender-point-line" src={currentSelectPoint} alt="current recommender-point"/>
            <img className="bot-utn-recommender-point" src={currentPoint} alt="recommender-point"/>
        </div>
        <h1 className="bot-utn-recommender-h1">
            ¡Empecemos!</h1>
        <p className="bot-utn-recommender-p">
        Con la ayuda de nuestra <strong style="font-weight: bold;">inteligencia artificial</strong>, vas a encontrar rápidamente los cursos que mejor se ajusten a tus objetivos.
        </p>
        <button onClick={sendNavigationChange} className="bot-utn-recommender-button">
            Siguiente &gt;
        </button>
    </div>
}
